// Display formatters. Server stores timestamps as 'YYYY-MM-DD HH:MM:SS' local
// in the tenant's timezone (no offset stored), so we treat them as already-local.

export function todayYmd(): string {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

function pad(n: number): string {
  return n.toString().padStart(2, '0');
}

/** "2026-05-06 14:00:00" → "2:00 PM" */
export function formatTime(ts: string): string {
  const [, time] = ts.split(' ');
  if (!time) return ts;
  const [h, m] = time.split(':').map((x) => parseInt(x, 10));
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${pad(m)} ${ampm}`;
}

/** "2026-05-06 14:00:00", "2026-05-06 15:15:00" → "2:00–3:15 PM" */
export function formatTimeRange(start: string, end: string): string {
  return `${formatTime(start)}–${formatTime(end)}`;
}

/** "2026-05-06 14:00:00" → "Wed, May 6" */
export function formatDate(ts: string): string {
  const d = new Date(ts.replace(' ', 'T'));
  return d.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

/** 4500 → "$45.00" */
export function formatCents(cents: number): string {
  return `$${(cents / 100).toFixed(2)}`;
}

/** "Bath (11-35 lbs)" → ["Bath", "11-35 lbs"] */
export function splitServiceName(name: string): { base: string; tier: string | null } {
  const m = /^(.*?)\s*\(([^)]+)\)\s*$/.exec(name);
  if (m) return { base: m[1].trim(), tier: m[2].trim() };
  return { base: name, tier: null };
}
